import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@/App.css";

import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG } from "@/lib/i18n";
import ScrollToTop from "@/lib/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

import Home from "@/pages/Home";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiesPage from "@/pages/CookiesPage";
import TermsPage from "@/pages/TermsPage";
import ThankYouPage from "@/pages/ThankYouPage";

const LangLayout = () => {
  const { lang } = useParams();
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return (
    <I18nProvider>
      <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
        <Header />
        <div className="flex-1">
          <LangRoutes />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
};

// Nested routes rendered inside LangLayout
const LangRoutes = () => (
  <Routes>
    <Route index element={<Home />} />
    <Route path="privacy" element={<PrivacyPage />} />
    <Route path="cookies" element={<CookiesPage />} />
    <Route path="terms" element={<TermsPage />} />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYouPage />} />
        <Route path="/privacy" element={<Navigate to={`/${DEFAULT_LANG}/privacy`} replace />} />
        <Route path="/cookies" element={<Navigate to={`/${DEFAULT_LANG}/cookies`} replace />} />
        <Route path="/terms" element={<Navigate to={`/${DEFAULT_LANG}/terms`} replace />} />
        <Route path=":lang/*" element={<LangLayout />} />
        <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
